import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { ValidationError } from 'ngx-lib';

@Component({
    selector: 'app-validation-error-message',
    templateUrl: './validation-error-message.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./validation-error-message.component.scss']
})
export class ValidationErrorMessageComponent {
    show = input<boolean>(false);

    errors = input<ValidationError[]>();

    showOnlyFirstError = input<boolean>(false);

    displayedErrors = computed(() => {
        const errors = this.errors() ?? [];
        if (!this.show() || !errors.length) {
            return [];
        }

        return this.showOnlyFirstError() ? errors.slice(0, 1) : errors;
    });
}
